import { toastr } from "react-redux-toastr";
import { client_v2, getApiErrorMessage } from "utils/api";

export const getBrandLabel = (id) => async (dispatch) => {
  try {
    dispatch({ type: "BRAND_LABEL_LOADING" });

    const { data } = await client_v2.get(`/brand_labels/${id}`);

    dispatch({
      type: "BRAND_LABEL_SUCCESS",
      data,
    });
  } catch (error) {
    dispatch({ type: "BRAND_LABEL_FAILURE" });
    toastr.error("Błąd", "Wystąpił błąd podczas pobierania");
    throw error;
  }
};

export const createBrandLabel = async (values) => {
  try {
    const {
      data: { id },
    } = await client_v2.post("/brand_labels", values);
    toastr.success("Sukces", "Etykieta markowa została dodana");
    return id;
  } catch (error) {
    toastr.error(
      "Błąd",
      getApiErrorMessage(error, "Wystąpił błąd podczas dodawania etykiety"),
    );
    throw error;
  }
};

export const updateBrandLabel = (id, values) => async (dispatch) => {
  try {
    await client_v2.put(`/brand_labels/${id}`, values);
    const { data } = await client_v2.get(`/brand_labels/${id}`);
    toastr.success("Sukces", "Etykieta markowa została zaktualizowana");

    dispatch({
      type: "BRAND_LABEL_SUCCESS",
      data,
    });
  } catch (error) {
    toastr.error(
      "Błąd",
      getApiErrorMessage(error, "Wystąpił błąd podczas aktualizowania"),
    );
    throw error;
  }
};

export const deleteBrandLabel = async (id) => {
  try {
    await client_v2.delete(`/brand_labels/${id}`);
    toastr.success("Sukces", "Etykieta markowa została usunięta");
  } catch (error) {
    toastr.error(
      "Błąd",
      getApiErrorMessage(error, "Wystąpił błąd podczas usuwania"),
    );
    throw error;
  }
};
